export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 3a1 1 0 01.824 1.566l-4.712 6.854a6.5 6.5 0 11-9.225 0L2.677 4.566A1 1 0 013.5 3h17zM12 11.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM5.4 5L9 10.233c.365-.19.751-.346 1.153-.465L13.181 5H5.4zM15.55 5l-2.88 4.533c.834.086 1.62.33 2.33.7L18.6 5h-3.05z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};